import { backendApi } from "./backendApi";
import { convertToCamel } from "@lib/convertToCamel";
import { GenerateTripPlanRequest, TripPlan } from "@dto/TripBuilder";

export const tripBuilderApi = backendApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    generateTripPlan: build.mutation<TripPlan, GenerateTripPlanRequest>({
      query: (request) => ({
        url: "/trip",
        method: "POST",
        body: request,
      }),
      transformResponse: (responseData) => {
        return convertToCamel(responseData) as TripPlan;
      },
    }),
  }),
});

export const { useGenerateTripPlanMutation } = tripBuilderApi;

export const {
  endpoints: { generateTripPlan },
} = tripBuilderApi;
